"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Anushavan.Hovsepyan
 * on 9/28/2016.
 */
var operators_1 = require("rxjs/operators");
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
var idm_session_data_provider_api_js_1 = require("@synisys/idm-session-data-provider-api-js");
var idm_um_permission_client_js_1 = require("@synisys/idm-um-permission-client-js");
var service_1 = require("../../api/service");
var portfolio_serialization_service_1 = require("./portfolio-serialization.service");
var from_1 = require("rxjs/observable/from");
var HttpPortfolioService = /** @class */ (function () {
    function HttpPortfolioService(_dataService, _knowledgeService, _languageService, _classifierService, _currentLanguageProvider, _applicationPropertiesService) {
        this._dataService = _dataService;
        this._knowledgeService = _knowledgeService;
        this._languageService = _languageService;
        this._classifierService = _classifierService;
        this._currentLanguageProvider = _currentLanguageProvider;
        this._applicationPropertiesService = _applicationPropertiesService;
        this.PORTFOLIO_SERVICE_URI_KEY = 'entity-search-service-url';
        this.URL_ENTITY_LOAD_PORTFOLIO_ITEMS = idm_common_util_frontend_1.StringTemplate.createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/entities/", ""], ["", "/entities/", ""])), 'serviceUri', 'systemName');
        this._portfolioSerializationService = new portfolio_serialization_service_1.PortfolioSerializationService(_knowledgeService, _languageService, _classifierService, this);
    }
    /**
     * Loads portfolio items.
     * @param {string} systemName - Category System Name
     * @param {PagingOptions} [paging] - The paging to serve items in accordance.
     * @param {SortingOptions} [sorting] - The sorting to serve items in accordance.
     * @param {any} [filters]
     * @param {Array<CategoryPermissionType>} categoryPermissionTypes - Category Permission Types to serve in accordance
     * default value for is VIEW
     * @returns {Observable<any>}
     */
    HttpPortfolioService.prototype.loadPortfolioItems = function (systemName, paging, sorting, filters, categoryPermissionTypes, compoundMainEntityfields) {
        var _this = this;
        if (categoryPermissionTypes === void 0) { categoryPermissionTypes = [idm_um_permission_client_js_1.CategoryPermissionType.EDIT]; }
        idm_common_util_frontend_1.PreconditionCheck.notNull(systemName);
        return from_1.from(this._applicationPropertiesService.getProperty(this.PORTFOLIO_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            var url = _this.URL_ENTITY_LOAD_PORTFOLIO_ITEMS.replaceTemplate({
                serviceUri: serviceUri,
                systemName: systemName,
            });
            var portfolioDataObservable = _this._currentLanguageProvider
                .getCurrentLanguage()
                .pipe(operators_1.switchMap(function (language) {
                var queryParams = [];
                queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
                if (paging !== undefined && paging !== null) {
                    queryParams.push(new idm_de_core_frontend_1.SearchParam('paging', paging));
                }
                if (sorting !== undefined && sorting !== null) {
                    queryParams.push(new idm_de_core_frontend_1.SearchParam('sortField', sorting.sortField));
                    queryParams.push(new idm_de_core_frontend_1.SearchParam('sortOrder', sorting.sortType === idm_de_core_frontend_1.SortType.ASC
                        ? 'ASC'
                        : 'DESC'));
                }
                if (categoryPermissionTypes !== undefined &&
                    categoryPermissionTypes !== null &&
                    categoryPermissionTypes.length !== 0) {
                    var categoryPermissionTypeNames = categoryPermissionTypes.map(function (categoryPermissionType) {
                        return idm_um_permission_client_js_1.CategoryPermissionType[categoryPermissionType];
                    });
                    queryParams.push(new idm_de_core_frontend_1.SearchParam('categoryPermissionTypes', categoryPermissionTypeNames.toString()));
                }
                queryParams.push(new idm_de_core_frontend_1.SearchParam('filter', filters || {}));
                return _this._dataService.load(url, queryParams);
            }));
            return _this._portfolioSerializationService.deserializeEntities(systemName, portfolioDataObservable, compoundMainEntityfields, categoryPermissionTypes);
        }));
    };
    /**
     * Loads portfolio items without serialization
     * @param {string} systemName - Category System Name
     * @param {string[]} filterFields
     * @param {string} nestedEntityInstanceName
     * @param {PagingOptions} [paging] - The paging to serve items in accordance.
     * @param {SortingOptions} [sorting] - The sorting to serve items in accordance.
     * @param {any} [filters]
     * @param {Array<CategoryPermissionType>} categoryPermissionTypes - Category Permission Types to serve in accordance
     * default value for is VIEW
     * @returns {Observable<any>}
     */
    HttpPortfolioService.prototype.loadEntitySearchItems = function (systemName, filterFields, nestedEntityInstanceName, paging, sorting, filters, categoryPermissionTypes) {
        var _this = this;
        if (categoryPermissionTypes === void 0) { categoryPermissionTypes = [idm_um_permission_client_js_1.CategoryPermissionType.EDIT]; }
        idm_common_util_frontend_1.PreconditionCheck.notNull(systemName);
        var url;
        return from_1.from(this._applicationPropertiesService.getProperty(this.PORTFOLIO_SERVICE_URI_KEY)).pipe(operators_1.switchMap(function (serviceUri) {
            url = _this.URL_ENTITY_LOAD_PORTFOLIO_ITEMS.replaceTemplate({
                serviceUri: serviceUri,
                systemName: systemName,
            });
            return _this._currentLanguageProvider.getCurrentLanguage();
        }), operators_1.switchMap(function (language) {
            var queryParams = [];
            queryParams.push(new idm_de_core_frontend_1.SearchParam('languageId', language.getId()));
            if (paging !== undefined && paging !== null) {
                queryParams.push(new idm_de_core_frontend_1.SearchParam('paging', paging));
            }
            if (sorting !== undefined && sorting !== null) {
                queryParams.push(new idm_de_core_frontend_1.SearchParam('sortField', sorting.sortField));
                queryParams.push(new idm_de_core_frontend_1.SearchParam('sortOrder', sorting.sortType === idm_de_core_frontend_1.SortType.ASC ? 'ASC' : 'DESC'));
            }
            if (categoryPermissionTypes !== undefined &&
                categoryPermissionTypes !== null &&
                categoryPermissionTypes.length !== 0) {
                var categoryPermissionTypeNames = categoryPermissionTypes.map(function (categoryPermissionType) {
                    return idm_um_permission_client_js_1.CategoryPermissionType[categoryPermissionType];
                });
                queryParams.push(new idm_de_core_frontend_1.SearchParam('categoryPermissionTypes', categoryPermissionTypeNames.toString()));
            }
            queryParams.push(new idm_de_core_frontend_1.SearchParam('filter', filters || {}));
            var entitySearchItemsData$ = _this._dataService.load(url, queryParams);
            return _this._portfolioSerializationService.deserializeEntitySearchItems(entitySearchItemsData$, filterFields, nestedEntityInstanceName);
        }));
    };
    HttpPortfolioService = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [service_1.DataService,
            idm_kb_service_client_js_1.KbService,
            idm_message_language_service_client_js_1.LanguageService,
            idm_classifier_service_client_js_1.ClassifierService,
            idm_session_data_provider_api_js_1.CurrentLanguageProvider,
            idm_application_properties_service_client_js_1.ApplicationPropertiesService])
    ], HttpPortfolioService);
    return HttpPortfolioService;
}());
exports.HttpPortfolioService = HttpPortfolioService;
var templateObject_1;
//# sourceMappingURL=http-portfolio.service.js.map